// Get gform element to extent 
import ArrayFrom from 'array-from'

class GravityForms {
  constructor() {
    this.form = this.getForms()
  }

  getForms() {
    var form = ''
    let forms = ArrayFrom(document.querySelectorAll('form'))
    forms.forEach((formElem) => {
      if (formElem) {
        if (typeof formElem.getAttribute('id') === 'string') {
          if (formElem.getAttribute('id').indexOf('gform_') === 0) {
            form = formElem
          }
        }
      }
    })
    return form
  }
}

export default GravityForms



// WEBPACK FOOTER //
// ./scripts/routes/gravity-forms/component.js